import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconRegistration: React.FC<Props> = ({
  width = 15,
  height = 18,
  // color = "#FFFFFF",
  // disabled = false,
}: Props) => (
  <svg width={width} 
        height={height} 
        viewBox="0 0 15 18" fill="none" 
        xmlns="http://www.w3.org/2000/svg">

        <path d="M14.1082 6.05833L9.10819 1.05833C8.99069 0.940834 8.83234 0.875 8.6665 0.875H3.6665C1.6515 0.875 0.541504 1.985 0.541504 4V14C0.541504 16.015 1.6515 17.125 3.6665 17.125H11.1665C13.1815 17.125 14.2915 16.015 14.2915 14V6.5C14.2915 6.33417 14.2257 6.175 14.1082 6.05833ZM9.2915 3.00917L12.1573 5.875H11.1665C9.85234 5.875 9.2915 5.31417 9.2915 4V3.00917ZM11.1665 15.875H3.6665C2.35234 15.875 1.7915 15.3142 1.7915 14V4C1.7915 2.68583 2.35234 2.125 3.6665 2.125H8.0415V4C8.0415 6.015 9.1515 7.125 11.1665 7.125H13.0415V14C13.0415 15.3142 12.4807 15.875 11.1665 15.875ZM10.9582 9C10.9582 9.345 10.6782 9.625 10.3332 9.625H4.49984C4.15484 9.625 3.87484 9.345 3.87484 9C3.87484 8.655 4.15484 8.375 4.49984 8.375H10.3332C10.6782 8.375 10.9582 8.655 10.9582 9ZM8.45817 12.3333C8.45817 12.6783 8.17817 12.9583 7.83317 12.9583H4.49984C4.15484 12.9583 3.87484 12.6783 3.87484 12.3333C3.87484 11.9883 4.15484 11.7083 4.49984 11.7083H7.83317C8.17817 11.7083 8.45817 11.9883 8.45817 12.3333Z" fill="#3E454D"/>
  </svg>
  
);

export default IconRegistration;
